const EquipmentGroupContants = {
  GET_EQUIPMENTGROUP_SUCCESS: "GET_EQUIPMENTGROUP_SUCCESS",
  GET_EQUIPMENTGROUP_FAILURE: "GET_EQUIPMENTGROUP_FAILURE",
  GET_NAVITEM_SUCCESS: "GET_NAVITEM_SUCCESS",
  GET_NAVITEM_FAILURE: "GET_NAVITEM_FAILURE",
  GET_EQUIPMENTLIST_SUCCESS: "GET_EQUIPMENTLIST_SUCCESS",
  GET_EQUIPMENTLIST_FAILURE: "GET_EQUIPMENTLIST_FAILURE",
  GET_TABSMENU_SUCCESS: "GET_TABSMENU_SUCCESS",
  GET_TABSMENU_FAILURE: "GET_TABSMENU_FAILURE",
  GET_INACTIVEQUIPMENT_SUCCESS: "GET_INACTIVEQUIPMENT_SUCCESS",
  GET_INACTIVEQUIPMENT_FAILURE: "GET_INACTIVEQUIPMENT_FAILURE",
  GET_AUFTRAEGELIST_SUCCESS: "GET_AUFTRAEGELIST_SUCCESS",
  GET_AUFTRAEGELIST_FAILURE: "GET_AUFTRAEGELIST_FAILURE",
  GET_UEBERFAELLIGEPRUFUNG_SUCCESS: "GET_UEBERFAELLIGEPRUFUNG_SUCCESS",
  GET_UEBERFAELLIGEPRUFUNG_FAILURE: "GET_UEBERFAELLIGEPRUFUNG_FAILURE",
  GET_NIOANLAGE_SUCCESS: "GET_NIOANLAGE_SUCCESS",
  GET_NIOANLAGE_FAILURE: "GET_NIOANLAGE_FAILURE",
  EXPORT_SUCCESS: "EXPORT_SUCCESS",
  EXPORT_FAILURE: "EXPORT_FAILURE",
  EXPORT_OVERDUE_SUCCESS: "EXPORT_OVERDUE_SUCCESS",
  EXPORT_OVERDUE_FAILURE: "EXPORT_OVERDUE_FAILURE",
  EXPORT_NIO_SUCCESS: "EXPORT_NIO_SUCCESS",
  EXPORT_NIO_FAILURE: "EXPORT_NIO_FAILURE",
  EXPORT_ORDEROVERVIEW_SUCCESS: "EXPORT_ORDEROVERVIEW_SUCCESS",
  EXPORT_ORDEROVERVIEW_FAILURE: "EXPORT_ORDEROVERVIEW_FAILURE",
  EXPORT_UEBERFAELLIGEPRUFUNG_SUCCESS: "EXPORT_UEBERFAELLIGEPRUFUNG_SUCCESS",
  EXPORT_UEBERFAELLIGEPRUFUNG_FAILURE: "EXPORT_UEBERFAELLIGEPRUFUNG_FAILURE",
  EXPORT_NIOANLAGE_SUCCESS: "EXPORT_NIOANLAGE_SUCCESS",
  EXPORT_NIOANLAGE_FAILURE: "EXPORT_NIOANLAGE_FAILURE",
  EXPORT_AUFTRAEGE_WITH_IMG_SUCCESS: "EXPORT_AUFTRAEGE_WITH_IMG_SUCCESS",
  EXPORT_AUFTRAEGE_WITH_IMG_FAILURE: "EXPORT_AUFTRAEGE_WITH_IMG_FAILURE",
  GET_ORG_EQUIPMENT_SUCCESS: "GET_ORG_EQUIPMENT_SUCCESS",
  GET_ORG_EQUIPMENT_FAILURE: "GET_ORG_EQUIPMENT_FAILURE",
  ADDORUPDATE_EQUIPMENT_GROUP_SUCCESS: "ADDORUPDATE_EQUIPMENT_GROUP_SUCCESS",
  ADDORUPDATE_EQUIPMENT_GROUP_FAILURE: "ADDORUPDATE_EQUIPMENT_GROUP_FAILURE",
  GET_PLANT_EQUIPMENT_GROUP_SUCCESS: "GET_PLANT_EQUIPMENT_GROUP_SUCCESS",
  GET_PLANT_EQUIPMENT_GROUP_FAILURE: "GET_PLANT_EQUIPMENT_GROUP_FAILURE",
  DELETE_EQUIPMENT_GROUP_SUCCESS: "DELETE_EQUIPMENT_GROUP_SUCCESS",
  DELETE_EQUIPMENT_GROUP_FAILURE: "DELETE_EQUIPMENT_GROUP_FAILURE",
  COPY_EQUIPMENT_GROUP_SUCCESS: "COPY_EQUIPMENT_GROUP_SUCCESS",
  COPY_EQUIPMENT_GROUP_FAILURE: "COPY_EQUIPMENT_GROUP_FAILURE",
  // ------------------- Designation Start -------------------
  ADDORUPDATE_EQUIPMENT_SUCCESS: "ADDORUPDATE_EQUIPMENT_SUCCESS",
  ADDORUPDATE_EQUIPMENT_FAILURE: "ADDORUPDATE_EQUIPMENT_FAILURE",
  GET_EQUIPMENT_SUCCESS: "GET_EQUIPMENT_SUCCESS",
  GET_EQUIPMENT_FAILURE: "GET_EQUIPMENT_FAILURE",
  ADD_EQUIPMENT_TO_EQU_GROUP_SUCCESS: "ADD_EQUIPMENT_TO_EQU_GROUP_SUCCESS",
  ADD_EQUIPMENT_TO_EQU_GROUP_FAILURE: "ADD_EQUIPMENT_TO_EQU_GROUP_FAILURE",
  DELETE_DESIGNATION_SUCCESS: "DELETE_DESIGNATION_SUCCESS",
  DELETE_DESIGNATION_FAILURE: "DELETE_DESIGNATION_FAILURE",
  GET_EQUIPMENT_BY_EQUGROUP_ID_SUCCESS: "GET_EQUIPMENT_BY_EQUGROUP_ID_SUCCESS",
  GET_EQUIPMENT_BY_EQUGROUP_ID_FAILURE: "GET_EQUIPMENT_BY_EQUGROUP_ID_FAILURE",
  DELETE_EQUIPMENT_FOR_EQUGROUP_SUCCESS:
    "DELETE_EQUIPMENT_FOR_EQUGROUP_SUCCESS",
  DELETE_EQUIPMENT_FOR_EQUGROUP_FAILURE:
    "DELETE_EQUIPMENT_FOR_EQUGROUP_FAILURE",
  // ------------------- Designation End -------------------
  // ------------------- Herstelleres Start -------------------
  GET_HERSTELLERS_SUCCESS: "GET_HERSTELLERS_SUCCESS",
  GET_HERSTELLERS_FAILURE: "GET_HERSTELLERS_FAILURE",
  ADD_OR_UPDATE_HERSTELLERS_SUCCESS: "ADD_OR_UPDATE_HERSTELLERS_SUCCESS",
  ADD_OR_UPDATE_HERSTELLERS_FAILURE: "ADD_OR_UPDATE_HERSTELLERS_FAILURE",
  DELETE_HERSTELLRS_SUCCESS: "DELETE_HERSTELLRS_SUCCESS",
  DELETE_HERSTELLRS_FAILURE: "DELETE_HERSTELLRS_FAILURE",
  GET_HERSTELLER_BY_EQUIPMENT_GROUP_ID_SUCCESS:
    "GET_HERSTELLER_BY_EQUIPMENT_GROUP_ID_SUCCESS",
  GET_HERSTELLER_BY_EQUIPMENT_GROUP_ID_FAILURE:
    "GET_HERSTELLER_BY_EQUIPMENT_GROUP_ID_FAILURE",
  ADD_HERSTELLER_BY_EQUIPMENT_GROUP_ID_SUCCESS:
    "ADD_HERSTELLER_BY_EQUIPMENT_GROUP_ID_SUCCESS",
  ADD_HERSTELLER_BY_EQUIPMENT_GROUP_ID_FAILURE:
    "ADD_HERSTELLER_BY_EQUIPMENT_GROUP_ID_FAILURE",
  DELETE_HERSTELLER_BY_EQUIPMENT_GROUP_SUCCESS:
    "DELETE_HERSTELLER_BY_EQUIPMENT_GROUP_SUCCESS",
  DELETE_HERSTELLER_BY_EQUIPMENT_GROUP_FAILURE:
    "DELETE_HERSTELLER_BY_EQUIPMENT_GROUP_FAILURE",
  // ------------------- Herstelleres End -------------------
  // ------------------- Function Start -------------------
  GET_FUNCTION_SUCCESS: "GET_FUNCTION_SUCCESS",
  GET_FUNCTION_FAILURE: "GET_FUNCTION_FAILURE",

  ADDORUPDATE_FUNCTION_TO_EQU_GRP_SUCCESS:
    "ADDORUPDATE_FUNCTION_TO_EQU_GRP_SUCCESS",
  ADDORUPDATE_FUNCTION_TO_EQU_GRP_FAILURE:
    "ADDORUPDATE_FUNCTION_TO_EQU_GRP_FAILURE",
  // ------------------- Function End -------------------
  // ------------------- Menu Start -------------------
  GET_MENU_SUCCESS: "GET_MENU_SUCCESS",
  GET_MENU_FAILURE: "GET_MENU_FAILURE",
  ADDORUPDATE_MENU_TO_EQU_GRP_SUCCESS: "ADDORUPDATE_MENU_TO_EQU_GRP_SUCCESS",
  ADDORUPDATE_MENU_TO_EQU_GRP_FAILURE: "ADDORUPDATE_MENU_TO_EQU_GRP_FAILURE",
  // ------------------- Menu End -------------------
  // ------------------- StandardAttributes Start -------------------
  GET_EQU_GUP_STANDARD_ATTRIBUTES_SUCCESS:
    "GET_EQU_GUP_STANDARD_ATTRIBUTES_SUCCESS",
  GET_EQU_GUP_STANDARD_ATTRIBUTES_FAILURE:
    "GET_EQU_GUP_STANDARD_ATTRIBUTES_FAILURE",
  ADDORUPDATE_EQU_GUP_STANDARD_ATTRIBUTES_SUCCESS:
    "ADDORUPDATE_EQU_GUP_STANDARD_ATTRIBUTES_SUCCESS",
  ADDORUPDATE_EQU_GUP_STANDARD_ATTRIBUTES_FAILURE:
    "ADDORUPDATE_EQU_GUP_STANDARD_ATTRIBUTES_FAILURE",
  REMOVE_STANDARD_ATTRIBUTES_EQU_GRP_SUCCESS:
    "REMOVE_STANDARD_ATTRIBUTES_EQU_GRP",
  REMOVE_STANDARD_ATTRIBUTES_EQU_GRP_FAILURE:
    "REMOVE_STANDARD_ATTRIBUTES_EQU_GRP_FAILURE",
  // ------------------- StandardAttributes End -------------------
  // --------------------Test Group Start -------------------------
  GET_TEST_GROUP_SUCCESS: "GET_TEST_GROUP_SUCCESS",
  GET_TEST_GROUP_FAILURE: "GET_TEST_GROUP_FAILURE",
  ADD_TEST_GROUP_TO_EQU_GROUP_SUCCESS: "ADD_TEST_GROUP_TO_EQU_GROUP_SUCCESS",
  ADD_TEST_GROUP_TO_EQU_GROUP_FAILURE: "ADD_TEST_GROUP_TO_EQU_GROUP_FAILURE",
  GET_TEST_GROUP_BY_EQUGROUP_ID_SUCCESS:
    "GET_TEST_GROUP_BY_EQUGROUP_ID_SUCCESS",
  GET_TEST_GROUP_BY_EQUGROUP_ID_FAILURE:
    "GET_TEST_GROUP_BY_EQUGROUP_ID_FAILURE",
  DELETE_TEST_GROUP_FOR_EQUGROUP_SUCCESS:
    "DELETE_TEST_GROUP_FOR_EQUGROUP_SUCCESS",
  DELETE_TEST_GROUP_FOR_EQUGROUP_FAILURE:
    "DELETE_TEST_GROUP_FOR_EQUGROUP_FAILURE",
  // --------------------Test Group End ---------------------------
  // --------------------FixedDate Start ---------------------------
  GET_FIXED_DATESET_SUCCESS: "GET_FIXED_DATESET_SUCCESS",
  GET_FIXED_DATESET_FAILURE: "GET_FIXED_DATESET_FAILURE",
  // --------------------FixedDate End ---------------------------

  GET_GRID_EQUIPMENTLIST_SUCCESS: "GET_GRID_EQUIPMENTLIST_SUCCESS",
  GET_GRID_EQUIPMENTLIST_FAILURE: "GET_GRID_EQUIPMENTLIST_FAILURE",

  GET_GRID_OVERDUE_EQUIPMENTLIST_SUCCESS:
    "GET_GRID_OVERDUE_EQUIPMENTLIST_SUCCESS",
  GET_GRID_OVERDUE_EQUIPMENTLIST_FAILURE:
    "GET_GRID_OVERDUE_EQUIPMENTLIST_FAILURE",

  GET_GRID_NIO_EQUIPMENTLIST_SUCCESS: "GET_GRID_NIO_EQUIPMENTLIST_SUCCESS",
  GET_GRID_NIO_EQUIPMENTLIST_FAILURE: "GET_GRID_NIO_EQUIPMENTLIST_FAILURE",

  GET_GRID_ORDEROVERVIEW_EQUIPMENTLIST_SUCCESS:
    "GET_GRID_ORDEROVERVIEW_EQUIPMENTLIST_SUCCESS",
  GET_GRID_ORDEROVERVIEW_EQUIPMENTLIST_FAILURE:
    "GET_GRID_ORDEROVERVIEW_EQUIPMENTLIST_FAILURE",

  GET_GRID_INACTIVE_EQUIPMENTLIST_SUCCESS:
    "GET_GRID_INACTIVE_EQUIPMENTLIST_SUCCESS",
  GET_GRID_INACTIVE_EQUIPMENTLIST_FAILURE:
    "GET_GRID_INACTIVE_EQUIPMENTLIST_FAILURE",

  GET_OPTION_EQUIP_GRP_SUCCESS: "GET_OPTION_EQUIP_GRP_SUCCESS",
  GET_OPTION_EQUIP_GRP_FAILURE: "GET_OPTION_EQUIP_GRP_FAILURE",
  GET_PARTICULE_EQ_GRP_SUCCESS: "GET_PARTICULE_EQ_GRP_SUCCESS",
  GET_PARTICULE_EQ_GRP_FAILURE: "GET_PARTICULE_EQ_GRP_FAILURE",
  GET_SUMMARY_EQ_GRP_SUCCESS: "GET_SUMMARY_EQ_GRP_SUCCESS",
  GET_SUMMARY_EQ_GRP_FAILURE: "GET_SUMMARY_EQ_GRP_FAILURE",

  GET_EQUIPMENTGROUP_BY_PLANT_SUCCESS: "GET_EQUIPMENTGROUP_BY_PLANT_SUCCESS",
  GET_EQUIPMENTGROUP_BY_PLANT_FAILURE: "GET_EQUIPMENTGROUP_BY_PLANT_FAILURE",

  SAVE_INSPECTION_REPORT_ATTR_SUCCESS: "SAVE_INSPECTION_REPORT_ATTR_SUCCESS",
  SAVE_INSPECTION_REPORT_ATTR_FAILURE: "SAVE_INSPECTION_REPORT_ATTR_FAILURE",

  GET_INSPECTION_REPORT_CONF_SUCCESS: "GET_INSPECTION_REPORT_CONF_SUCCESS",
  GET_INSPECTION_REPORT_CONF_FAILURE: "GET_INSPECTION_REPORT_CONF_FAILURE",

  GET_BULK_INSPECTION_REPORT_SUCCESS: "GET_BULK_INSPECTION_REPORT_SUCCESS",
  GET_BULK_INSPECTION_REPORT_FAILURE: "GET_BULK_INSPECTION_REPORT_FAILURE",

  GET_MANAGE_TICKET_EQUIPMENT_GRP_SUCCESS:
    "GET_MANAGE_TICKET_EQUIPMENT_GRP_SUCCESS",
  GET_MANAGE_TICKET_EQUIPMENT_GRP_FAILURE:
    "GET_MANAGE_TICKET_EQUIPMENT_GRP_FAILURE",
};
export default EquipmentGroupContants;
